import { render, staticRenderFns } from "./UpDownButton.vue?vue&type=template&id=665a321a&scoped=true"
import script from "./UpDownButton.vue?vue&type=script&lang=js"
export * from "./UpDownButton.vue?vue&type=script&lang=js"
import style0 from "./UpDownButton.vue?vue&type=style&index=0&id=665a321a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a321a",
  null
  
)

export default component.exports